import { Zap } from "lucide-react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white/60">
      <div className="container-x flex flex-col items-center justify-between gap-6 py-10 md:flex-row">
        <div className="flex items-center gap-2">
          <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent text-white">
            <Zap size={16} strokeWidth={2.6} />
          </span>
          <span className="font-display text-base font-bold tracking-tight text-ink">S1EP VELOCITY</span>
        </div>
        <p className="text-sm text-ink-muted">The Sub-60-Second Omnichannel Lead Capture Engine.</p>
        <div className="flex items-center gap-6 text-sm text-ink-muted">
          <span>© {new Date().getFullYear()} S1EP</span>
          <Link data-testid="admin-link" to="/admin/leads" className="font-medium text-ink-soft transition-colors hover:text-accent">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
